module.exports = __webpack_public_path__ + "propertypanel-logo.png?186580cf998c6c31fb94b38dba571916";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/propertypanel-logo.png
// module id = 21
// module chunks = 0